module.exports = __webpack_public_path__ + "img/envtemperature.ce3cead0.svg";